import { render, staticRenderFns } from "./PeopleIcon.vue?vue&type=template&id=3b3cef7f"
import script from "./PeopleIcon.vue?vue&type=script&lang=js"
export * from "./PeopleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports